<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Report.isForm" flat class="pa-2 text-no-wrap">
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="Report.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="Report.total"
          :items-per-page="Report.filter.limit"
          :footer-props="{ itemsPerPageOptions: Report.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.report") }}</h2>
              </v-layout>
              <v-spacer />
              <div class="mb-3" :style="{ width: '250px' }">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  v-model="Report.search"
                  @keydown.enter="_fnSearch"
                  :placeholder="$t(`table.search`) + ' post id, user id'"
                />
              </div>
            </v-layout>
          </template>
          <template #[`item.createdAt`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: POST, p: APPROVE }])"
            />
          </template>
          <template #[`item.user`]="{ item }">
            <span v-if="item.user" v-html="_fnBuildInfo(item)" />
          </template>
          <template #[`item.reports`]="{ item }">
            <span v-html="_fnBuildReport(item.reports)" />
          </template>
          <template #[`item.images`]="{ item }">
            <v-upload
              :size="30"
              class="my-1"
              :images="item.images"
              :readonly="true"
            />
          </template>
          <template #[`item.status`]="{ item }">
            <span
              :class="
                item.status.id == '600034de67506a5472321bbf'
                  ? 'success--text'
                  : item.status.id == '600034de67506a5472321bbe'
                  ? 'warning--text'
                  : 'info--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.updatedBy`]="{ item }">
            <span v-if="item.updatedBy">{{ item.updatedBy.name }}</span>
          </template>
          <template #[`item.updatedAt`]="{ item }">
            {{ item.updatedAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "Report",
      pagings: {},
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "createdAt",
          width: "10px",
        },
        {
          text: this.$t(`table.info`),
          value: "user",
          width: "10px",
        },
        {
          text: this.$t(`table.content`),
          value: "content",
        },
        {
          text: this.$t(`table.report`),
          value: "reports",
          width: "10px",
        },
        {
          text: this.$t(`table.image`),
          value: "images",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedBy`),
          value: "updatedBy",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedAt`),
          value: "updatedAt",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "Report.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = {};
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          status: this[this.model].obj.status.id,
        };
      }
    },
    _fnCallListView() {
      this.fnCallListView({
        url: "/v1/admin/report",
        model: this.model,
      });
    },
    _fnSearch({ target: { value } }) {
      if (!value) delete this[this.model].filter.$text;
      else this[this.model].filter.$text = value;
      this._fnCallListView();
    },
    _fnBuildReport(items) {
      return items.reduce((init, item) => init + `<li>${item}</li>`, "");
    },
    _fnBuildInfo(item) {
      return `
          <li>${this.$t("table.name")}: <span class="primary--text">${
        item.user.name
      }</span></li>
          <li>${this.$t("table.user")}: <span>${item.user.id}</span></li>
          <li>${this.$t("table.post")}: <span>${item.post}</span></li>
      `;
    },
  },
};
</script>
